import React from 'react';
import {connect} from 'react-redux';
import {changeDeviceSettings} from '../../../common/device/actions';
import {dashedToCamelCase, showPrintAddress} from '../../../common/lib/util';

class SelectKitchenPrint extends React.Component {

  static propTypes = {
      msg: React.PropTypes.object,
    kitchenPrintAddress: React.PropTypes.string,
    kitchenPrintType: React.PropTypes.string,
    kitchenPrintTypeOptions: React.PropTypes.object,
    openPopup: React.PropTypes.func.isRequired,
    kitchenPrintLength: React.PropTypes.number
  };

  constructor(props) {
    super(props);

    this.openPopup = this.openPopup.bind(this);
  }

  openPopup() {
    const {openPopup} = this.props;
    openPopup();
  }

  render() {
    const {kitchenPrintType, kitchenPrintTypeOptions, kitchenPrintAddress, kitchenPrintLength, msg} = this.props;

    return (
      <div className="table-row">
        <div className="table-cell" style={{width: '55.55%'}}>
          <div className="boxBtn text-left text-black">
            <div className="boxBtn-inner">
              <div className="settings-name">
                <span className="settings-name-name">{msg.settings.printTypeOrder.title}</span>
                <span className="settings-name-info">{msg.settings.printTypeOrder.subtitle}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="table-cell" style={{width: '22.22%'}}>
          <div className="boxBtn text-black text-l">
            <div className="boxBtn-inner">
              <span>
                {msg.settings.printType[dashedToCamelCase(kitchenPrintType)]} {!!kitchenPrintType && !!kitchenPrintAddress && showPrintAddress(kitchenPrintType) && `(${kitchenPrintAddress})`}
                {kitchenPrintType.indexOf('escpos') > -1 && <br/>}
                {kitchenPrintType.indexOf('escpos') > -1 && `${kitchenPrintLength} ${msg.settings.printTypeOrder.charOnLine}`}
              </span>
            </div>
          </div>
        </div>
        <div className="table-cell" style={{width: '22.22%'}}>
          <div className="boxBtn color-green text-l">
            <div className="boxBtn-inner" onClick={this.openPopup}>
              <span>{msg.settings.printTypeOrder.change}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
  kitchenPrintAddress: state.device.kitchenPrintAddress,
  kitchenPrintType: state.device.kitchenPrintType,
  kitchenPrintTypeOptions: state.device.kitchenPrintTypeOptions,
  kitchenPrintLength: state.device.kitchenPrintLength
}), {changeDeviceSettings})(SelectKitchenPrint);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/SelectKitchenPrint.js